var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJavascript(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 109,
    height: 114,
    viewBox: "0 0 109 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H109V114H0V0Z",
    fill: "#F7DF1E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6601 95.2667L37.0015 89.9871C38.6107 92.9712 40.0746 95.496 43.586 95.496C46.9518 95.496 49.0739 94.1189 49.0739 88.7628V52.337H59.3171V88.9142C59.3171 100.01 53.0982 105.061 44.0251 105.061C35.8309 105.061 31.0743 100.622 28.6599 95.2658",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64.881 94.1188L73.2214 89.0682C75.4169 92.8183 78.2705 95.5729 83.3187 95.5729C87.563 95.5729 90.2695 93.3535 90.2695 90.2925C90.2695 86.6194 87.4893 85.3183 82.8064 83.1764L80.2463 82.0277C72.8559 78.7378 67.9535 74.6056 67.9535 65.8817C67.9535 57.8467 73.8068 51.7245 82.9531 51.7245C89.4651 51.7245 94.1478 54.097 97.5131 60.2955L89.5378 65.6519C87.7817 62.3616 85.8799 61.0609 82.9533 61.0609C79.9534 61.0609 78.0509 63.0505 78.0509 65.6519C78.0509 68.866 79.9534 70.1672 84.343 72.1569L86.9036 73.3047C95.6107 77.2077 100.513 81.1865 100.513 90.1394C100.513 99.782 93.2696 105.062 83.5385 105.062C74.0267 105.062 67.8804 100.317 64.881 94.1188Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJavascript);
export default __webpack_public_path__ + "static/media/javascript.0bf2ef3c3caa385a4813d55bb76c8fb5.svg";
export { ForwardRef as ReactComponent };